var _linearGradient, _linearGradient2, _linearGradient3, _filter, _filter2, _filter3, _linearGradient4, _filter4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient0, _linearGradient1, _path, _path2, _tspan, _tspan2, _path3, _path4, _path5, _path6, _tspan3, _tspan4, _path7, _path8, _path9, _tspan5, _tspan6, _path0, _path1, _path10, _tspan7, _tspan8, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _tspan9, _tspan0, _rect, _path19, _g, _rect2, _path20, _rect3, _path21, _g2, _rect4, _g3, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _tspan1, _tspan10, _tspan11, _tspan12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65.863mm",
    height: "66.104mm",
    viewBox: "0 0 65.863 66.104",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0a0a0a",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3a3a3a",
    offset: 1
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -159.26,
    x2: -54.077,
    y1: 74.044,
    y2: 74.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d0b247",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fadd86",
    offset: 1
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -159.26,
    x2: -120.69,
    y1: 86.992,
    y2: 86.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe9a3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdd71",
    offset: 1
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "p",
    x: -0.17929,
    y: -0.11173,
    width: 1.3371,
    height: 1.2235,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.49804,
    in: "SourceGraphic",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 0,
    in: "blur",
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "o",
    x: -0.17929,
    y: -0.11173,
    width: 1.3371,
    height: 1.2235,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.49804,
    in: "SourceGraphic",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 0,
    in: "blur",
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "n",
    x: -0.15783,
    y: -0.11173,
    width: 1.38,
    height: 1.2235,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.49804,
    in: "SourceGraphic",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 0,
    in: "blur",
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 67.488,
    x2: 114.23,
    y1: 124.74,
    y2: 124.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a6a6a6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "m",
    x: -0.04877,
    y: -0.089556,
    width: 1.0975,
    height: 1.1859,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(0,0,0)",
    floodOpacity: 0.49804,
    in: "SourceGraphic",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    result: "blur",
    stdDeviation: 0.8
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0.1,
    in: "blur",
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m67.623 108.06-0.13486 24.777 46.356 0.38389 0.24668-25.16z",
    fill: "#fff",
    style: {
      paintOrder: "stroke markers fill"
    }
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 103.24,
    x2: 98.874,
    y1: 96.421,
    y2: 122.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 77.332,
    x2: 83.488,
    y1: 96.382,
    y2: 124.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424",
    offset: 1
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 15.516,
    x2: 15.516,
    y1: 34,
    gradientTransform: "translate(-8.3759e-7 .48669)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323232",
    stopOpacity: 0.81326,
    offset: 0.011036
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7f7f7",
    offset: 1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.1255,
    y: 18.47,
    width: 5.0929,
    height: 10.453,
    fill: "#f9f9f9",
    strokeLinejoin: "round",
    strokeWidth: 0.2894,
    style: {
      paintOrder: "stroke markers fill"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.346,
    y: 18.47,
    width: 5.0929,
    height: 10.453,
    fill: "#f9f9f9",
    strokeLinejoin: "round",
    strokeWidth: 0.2894,
    style: {
      paintOrder: "stroke markers fill"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.439,
    y: 18.47,
    width: 4.4351,
    height: 10.453,
    fill: "#f9f9f9",
    strokeLinejoin: "round",
    strokeWidth: 0.2894,
    style: {
      paintOrder: "stroke markers fill"
    }
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 80,
    x2: 105,
    y1: 160.97,
    y2: 160.97,
    gradientTransform: "translate(68.473 -278.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001854",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004bd8",
    offset: 1
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 80,
    x2: 105,
    y1: 160.97,
    y2: 160.97,
    gradientTransform: "translate(-228.47 -68.473)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  })), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 80,
    x2: 105,
    y1: 160.97,
    y2: 160.97,
    gradientTransform: "translate(-228.47 -43.473)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  })), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 80,
    x2: 105,
    y1: 160.97,
    y2: 160.97,
    gradientTransform: "translate(68.473 -68.473)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-72.068 -115.45)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.068,
    y: 115.57,
    width: 65.863,
    height: 65.863,
    display: "none",
    fill: "none",
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.524 25.379)",
    display: "none"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m96.716 90.214 0.01027 15.856h-0.1556 17.178m-46.575 49.968v-65.834h29.527l17.045 15.859 0.0332 49.975z",
    display: "inline",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.31121
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m84.69 138.32h14.934m2.2027 0h8.2442m-41.077-9.3094h30.63m-21.887-18.619h17.821m-26.564 0h7.215m5.3826-9.3094h12.104m-11.603-6.2062h7.0729m0.74761 0h3.7829m-24.702 58.959h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h12.516m-12.516-3.1031h41.077m-41.077-3.1031h41.077m-8.8618-3.1031h8.8618m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-12.985-3.1031h12.985m-41.077-3.1031h24.702m-24.702-3.1031h24.702m-24.702-3.1031h10.138m-10.138-3.1031h24.702m-24.702-3.1031h12.351",
    display: "inline",
    fill: "none",
    opacity: 0.4,
    stroke: "#000",
    strokeWidth: 0.29066
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.76905 0 0 .17859 -107.93 67.416)",
    display: "inline",
    fill: "none",
    fontFamily: "'Agency FB'",
    fontSize: "1.4678px",
    fontStretch: "condensed",
    fontWeight: "bold",
    letterSpacing: "0px",
    opacity: 0.4,
    stroke: "#000000",
    strokeWidth: 0.052309,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 0,
      shapeInside: "url(#rect20-9)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 250.4375,
    y: 397.51636
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#4d4d4d",
    stroke: "#4d4d4d"
  }, "if you are reading this text you are gay")))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.77016 0 0 .18349 -110.08 22.013)",
    display: "inline",
    fill: "#4d4d4d",
    fontFamily: "'Agency FB'",
    fontSize: "1.4678px",
    fontStretch: "condensed",
    fontWeight: "bold",
    letterSpacing: "0px",
    opacity: 0.4,
    strokeWidth: 0.053,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 0,
      shapeInside: "url(#rect20-0-5)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 250.4375,
    y: 397.51636
  }, "hire me please"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m96.919 98.302v-7.5852l0.33451 0.3132c0.18398 0.17241 3.6924 3.4298 7.7966 7.2391 4.1041 3.8092 7.6234 7.0816 7.8206 7.272l0.35852 0.34615h-16.31z",
    display: "inline",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.37852 0 0 .37311 145.86 115.06)",
    display: "none"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m-158.86 146.88 0.31734-145.68 102.14 0.16311 1.9256 145.35z",
    display: "inline",
    fill: "url(#e)",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5852 .36258 0 1.6082 -241.37 -139.4)",
    display: "inline",
    filter: "url(#o)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m96.716 90.214 0.01027 15.856h-0.1556 17.178m-46.575 49.968v-65.834h29.527l17.045 15.859 0.0332 49.975z",
    display: "inline",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.31121
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m84.69 138.32h14.934m2.2027 0h8.2442m-41.077-9.3094h30.63m-21.887-18.619h17.821m-26.564 0h7.215m5.3826-9.3094h12.104m-11.603-6.2062h7.0729m0.74761 0h3.7829m-24.702 58.959h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h12.516m-12.516-3.1031h41.077m-41.077-3.1031h41.077m-8.8618-3.1031h8.8618m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-12.985-3.1031h12.985m-41.077-3.1031h24.702m-24.702-3.1031h24.702m-24.702-3.1031h10.138m-10.138-3.1031h24.702m-24.702-3.1031h12.351",
    display: "inline",
    fill: "none",
    opacity: 0.4,
    stroke: "#000",
    strokeWidth: 0.29066
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.76905 0 0 .17859 -107.93 67.416)",
    display: "inline",
    fill: "none",
    fontFamily: "'Agency FB'",
    fontSize: "1.4678px",
    fontStretch: "condensed",
    fontWeight: "bold",
    letterSpacing: "0px",
    opacity: 0.4,
    stroke: "#000000",
    strokeWidth: 0.052309,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 0,
      shapeInside: "url(#rect20-02)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 250.4375,
    y: 397.51636
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#4d4d4d",
    stroke: "#4d4d4d"
  }, "if you are reading this text you are gay")))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.77016 0 0 .18349 -110.08 22.013)",
    display: "inline",
    fill: "#4d4d4d",
    fontFamily: "'Agency FB'",
    fontSize: "1.4678px",
    fontStretch: "condensed",
    fontWeight: "bold",
    letterSpacing: "0px",
    opacity: 0.4,
    strokeWidth: 0.053,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 0,
      shapeInside: "url(#rect20-0-17)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 250.4375,
    y: 397.51636
  }, "hire me please"))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m96.919 98.302v-7.5852l0.33451 0.3132c0.18398 0.17241 3.6924 3.4298 7.7966 7.2391 4.1041 3.8092 7.6234 7.0816 7.8206 7.272l0.35852 0.34615h-16.31z",
    display: "inline",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5852 .36258 0 1.6082 -248.6 -133.06)",
    display: "inline",
    filter: "url(#p)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m96.716 90.214 0.01027 15.856h-0.1556 17.178m-46.575 49.968v-65.834h29.527l17.045 15.859 0.0332 49.975z",
    display: "inline",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.31121
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m84.69 138.32h14.934m2.2027 0h8.2442m-41.077-9.3094h30.63m-21.887-18.619h17.821m-26.564 0h7.215m5.3826-9.3094h12.104m-11.603-6.2062h7.0729m0.74761 0h3.7829m-24.702 58.959h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h12.516m-12.516-3.1031h41.077m-41.077-3.1031h41.077m-8.8618-3.1031h8.8618m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-12.985-3.1031h12.985m-41.077-3.1031h24.702m-24.702-3.1031h24.702m-24.702-3.1031h10.138m-10.138-3.1031h24.702m-24.702-3.1031h12.351",
    display: "inline",
    fill: "none",
    opacity: 0.4,
    stroke: "#000",
    strokeWidth: 0.29066
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.76905 0 0 .17859 -107.93 67.416)",
    display: "inline",
    fill: "none",
    fontFamily: "'Agency FB'",
    fontSize: "1.4678px",
    fontStretch: "condensed",
    fontWeight: "bold",
    letterSpacing: "0px",
    opacity: 0.4,
    stroke: "#000000",
    strokeWidth: 0.052309,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 0,
      shapeInside: "url(#rect57)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 250.4375,
    y: 397.51636
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#4d4d4d",
    stroke: "#4d4d4d"
  }, "if you are reading this text you are gay")))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.77016 0 0 .18349 -110.08 22.013)",
    display: "inline",
    fill: "#4d4d4d",
    fontFamily: "'Agency FB'",
    fontSize: "1.4678px",
    fontStretch: "condensed",
    fontWeight: "bold",
    letterSpacing: "0px",
    opacity: 0.4,
    strokeWidth: 0.053,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 0,
      shapeInside: "url(#rect58)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 250.4375,
    y: 397.51636
  }, "hire me please"))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m96.919 98.302v-7.5852l0.33451 0.3132c0.18398 0.17241 3.6924 3.4298 7.7966 7.2391 4.1041 3.8092 7.6234 7.0816 7.8206 7.272l0.35852 0.34615h-16.31z",
    display: "inline",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5852 .36258 0 1.6082 -261.4 -129.72)",
    display: "inline",
    filter: "url(#n)"
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m96.716 90.214 0.01027 15.856h-0.1556 17.178m-46.575 49.968v-65.834h29.527l17.045 15.859 0.0332 49.975z",
    display: "inline",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.31121
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m84.69 138.32h14.934m2.2027 0h8.2442m-41.077-9.3094h30.63m-21.887-18.619h17.821m-26.564 0h7.215m5.3826-9.3094h12.104m-11.603-6.2062h7.0729m0.74761 0h3.7829m-24.702 58.959h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h12.516m-12.516-3.1031h41.077m-41.077-3.1031h41.077m-8.8618-3.1031h8.8618m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-12.985-3.1031h12.985m-41.077-3.1031h24.702m-24.702-3.1031h24.702m-24.702-3.1031h10.138m-10.138-3.1031h24.702m-24.702-3.1031h12.351",
    display: "inline",
    fill: "none",
    opacity: 0.4,
    stroke: "#000",
    strokeWidth: 0.29066
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.76905 0 0 .17859 -107.93 67.416)",
    display: "inline",
    fill: "none",
    fontFamily: "'Agency FB'",
    fontSize: "1.4678px",
    fontStretch: "condensed",
    fontWeight: "bold",
    letterSpacing: "0px",
    opacity: 0.4,
    stroke: "#000000",
    strokeWidth: 0.052309,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 0,
      shapeInside: "url(#rect53)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 250.4375,
    y: 397.51636
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#4d4d4d",
    stroke: "#4d4d4d"
  }, "if you are reading this text you are gay")))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.77016 0 0 .18349 -110.08 22.013)",
    display: "inline",
    fill: "#4d4d4d",
    fontFamily: "'Agency FB'",
    fontSize: "1.4678px",
    fontStretch: "condensed",
    fontWeight: "bold",
    letterSpacing: "0px",
    opacity: 0.4,
    strokeWidth: 0.053,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 0,
      shapeInside: "url(#rect54)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 250.4375,
    y: 397.51636
  }, "hire me please"))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m96.919 98.302v-7.5852l0.33451 0.3132c0.18398 0.17241 3.6924 3.4298 7.7966 7.2391 4.1041 3.8092 7.6234 7.0816 7.8206 7.272l0.35852 0.34615h-16.31z",
    display: "inline",
    fill: "#fff"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m-125.31 172.81-33.555-25.929 0.31734-145.68 37.42 30.252 0.0361 90.721-3.4518 4.1722z",
    display: "inline",
    fill: "url(#f)",
    strokeWidth: 0
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.9857 0 0 .99998 130.89 -70.315)",
    d: "m-290.99 92.918v120.5",
    fill: "#ffe9a3",
    stroke: "#ffdf78",
    strokeWidth: 0.52917
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.9857 0 0 .99998 130.89 -70.315)",
    d: "m-289.45 94.005v118.23",
    fill: "#ffe9a3",
    stroke: "#ffdf78",
    strokeWidth: 0.52917
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.9857 0 0 .99998 130.89 -70.315)",
    d: "m-290.46 92.918v120.5",
    fill: "#fff5d6",
    stroke: "#ffeeb9",
    strokeWidth: 0.52917
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.9857 0 0 .99998 130.89 -70.315)",
    d: "m-288.91 94.011v118.23",
    fill: "#ffeeb9",
    stroke: "#ffeeb9",
    strokeWidth: 0.52917
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.524 25.379)",
    display: "none"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m96.716 90.214 0.01027 15.856h-0.1556 17.178m-46.575 49.968v-65.834h29.527l17.045 15.859 0.0332 49.975z",
    display: "inline",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.31121
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m84.69 138.32h14.934m2.2027 0h8.2442m-41.077-9.3094h30.63m-21.887-18.619h17.821m-26.564 0h7.215m5.3826-9.3094h12.104m-11.603-6.2062h7.0729m0.74761 0h3.7829m-24.702 58.959h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h12.516m-12.516-3.1031h41.077m-41.077-3.1031h41.077m-8.8618-3.1031h8.8618m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-41.077-3.1031h41.077m-12.985-3.1031h12.985m-41.077-3.1031h24.702m-24.702-3.1031h24.702m-24.702-3.1031h10.138m-10.138-3.1031h24.702m-24.702-3.1031h12.351",
    display: "inline",
    fill: "none",
    opacity: 0.4,
    stroke: "#000",
    strokeWidth: 0.29066
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.76905 0 0 .17859 -107.93 67.416)",
    display: "inline",
    fill: "none",
    fontFamily: "'Agency FB'",
    fontSize: "1.4678px",
    fontStretch: "condensed",
    fontWeight: "bold",
    letterSpacing: "0px",
    opacity: 0.4,
    stroke: "#000000",
    strokeWidth: 0.052309,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 0,
      shapeInside: "url(#rect24)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 250.4375,
    y: 397.51636
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#4d4d4d",
    stroke: "#4d4d4d"
  }, "if you are reading this text you are gay")))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.77016 0 0 .18349 -110.08 22.013)",
    display: "inline",
    fill: "#4d4d4d",
    fontFamily: "'Agency FB'",
    fontSize: "1.4678px",
    fontStretch: "condensed",
    fontWeight: "bold",
    letterSpacing: "0px",
    opacity: 0.4,
    strokeWidth: 0.053,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 0,
      shapeInside: "url(#rect25)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }, _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    x: 250.4375,
    y: 397.51636
  }, "hire me please"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.022,
    y: 115.36,
    width: 50.908,
    height: 21.722,
    ry: 4.116,
    display: "inline",
    fill: "#f00",
    stroke: "#800000",
    strokeWidth: 0.26458
  })), /*#__PURE__*/React.createElement("text", {
    x: 68.994164,
    y: 133.79527,
    fill: "#ffffff",
    fontFamily: "Arial",
    fontSize: "21.151px",
    letterSpacing: "0px",
    strokeWidth: 0.56654,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 0
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 68.994164,
    y: 133.79527,
    fill: "#ffffff",
    fontFamily: "Arial",
    fontSize: "21.151px",
    strokeWidth: 0.56654,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "PDF")), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m96.919 98.302v-7.5852l0.33451 0.3132c0.18398 0.17241 3.6924 3.4298 7.7966 7.2391 4.1041 3.8092 7.6234 7.0816 7.8206 7.272l0.35852 0.34615h-16.31z",
    display: "inline",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0103 0 0 1 14.105 25.379)",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.513,
    y: 90.048,
    width: 46.916,
    height: 66.145,
    ry: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .69961)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.779,
    y: 92.567,
    width: 5.1626,
    height: 5.1626
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.779,
    y: 100.36,
    width: 5.1626,
    height: 5.1626,
    display: "inline"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.779,
    y: 108.15,
    width: 5.1626,
    height: 5.1626,
    display: "inline"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.779,
    y: 115.94,
    width: 5.1626,
    height: 5.1626,
    display: "inline"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.779,
    y: 123.74,
    width: 5.1626,
    height: 5.1626,
    display: "inline"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.779,
    y: 131.53,
    width: 5.1626,
    height: 5.1626,
    display: "inline"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.779,
    y: 139.32,
    width: 5.1626,
    height: 5.1626,
    display: "inline"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.779,
    y: 147.11,
    width: 5.1626,
    height: 5.1626,
    display: "inline"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.221 .69961)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.779,
    y: 92.567,
    width: 5.1626,
    height: 5.1626
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.779,
    y: 100.36,
    width: 5.1626,
    height: 5.1626,
    display: "inline"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.779,
    y: 108.15,
    width: 5.1626,
    height: 5.1626,
    display: "inline"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.779,
    y: 115.94,
    width: 5.1626,
    height: 5.1626,
    display: "inline"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.779,
    y: 123.74,
    width: 5.1626,
    height: 5.1626,
    display: "inline"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.779,
    y: 131.53,
    width: 5.1626,
    height: 5.1626,
    display: "inline"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.779,
    y: 139.32,
    width: 5.1626,
    height: 5.1626,
    display: "inline"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.779,
    y: 147.11,
    width: 5.1626,
    height: 5.1626,
    display: "inline"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m97.864 123.12-15.786 7.8932v-15.786l15.786 7.8931",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.595 0 0 1.6613 -39.304 -56.036)",
    display: "none"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 67.018,
    y: 90.048,
    width: 46.916,
    height: 66.145,
    display: "none",
    fill: "none"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m74.281 132.37h32.388m-32.388-18.508h32.388m-34.702 9.2538h37.015m-18.508 18.508s-10.411-4.6269-10.411-18.508 10.411-18.508 10.411-18.508 10.411 4.6269 10.411 18.508-10.411 18.508-10.411 18.508m0-37.015v37.015m18.508-18.508c0 10.222-8.2861 18.508-18.508 18.508-10.221 0-18.508-8.2861-18.508-18.508 0-10.221 8.2861-18.508 18.508-18.508 10.222 0 18.508 8.2861 18.508 18.508z",
    display: "inline",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.7761
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 69.828,
    y: 117.89,
    width: 41.295,
    height: 10.462,
    ry: 3.1337,
    fill: "#0000d4"
  })), /*#__PURE__*/React.createElement("text", {
    x: 76.513344,
    y: 126.64742,
    fill: "#ffffff",
    fontFamily: "Arial",
    fontSize: "9.8534px",
    fontWeight: "bold",
    letterSpacing: "0px",
    strokeWidth: 0.26393,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 0
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 76.513344,
    y: 126.64742,
    fill: "#ffffff",
    fontFamily: "Arial",
    fontSize: "9.8534px",
    fontWeight: "bold",
    strokeWidth: 0.26393,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "WWW")), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m291.59 424.95c0-0.23985 2.947-3.4896 5.0665-5.5871 6.2136-6.1488 13.289-10.786 21.509-14.096 1.2476-0.50244 2.3352-0.88918 2.417-0.85941 0.0818 0.0298-0.68901 0.96894-1.7128 2.087-4.6155 5.0406-8.7351 10.865-11.546 16.324l-1.149 2.2315-7.292 3e-3c-4.0106 2e-3 -7.292-0.0448-7.292-0.10321zm27.744-1.5291c3.0786-4.7866 6.1906-8.6106 10.112-12.426 2.0085-1.9539 4.8837-4.4349 6.409-5.5303l0.81216-0.58324v20.175h-18.385zm27.94-8.4627c0-8.05 0.0448-10.064 0.22097-9.9301 5.9689 4.5341 11.019 9.7044 15.12 15.478 1.1183 1.5748 2.8673 4.2948 2.8673 4.4592 0 0.0497-4.0968 0.0903-9.104 0.0903h-9.104zm29.61 8.3797c-2.9262-5.674-7.4799-12.126-12.001-17.003-0.93749-1.0114-1.6723-1.8711-1.633-1.9105 0.16097-0.16097 3.757 1.3115 6.7423 2.7609 6.5606 3.1851 11.712 6.7815 16.838 11.756 2.0473 1.9867 5.0273 5.231 5.4132 5.8934 0.10216 0.1753-1.3804 0.22053-7.1737 0.21881l-7.3025-2e-3zm7.7884 22.003c-0.0369-0.12154-0.24202-1.0165-0.45583-1.9887-0.35424-1.6109-1.7385-6.636-2.033-7.3804-0.11557-0.29208 0.36083-0.30936 8.53-0.30936h8.6524l0.98929 2.0771c1.0981 2.3055 1.8651 4.1734 2.6132 6.364l0.49809 1.4584h-9.3635c-7.3372 0-9.378-0.0478-9.4306-0.22097zm-37.398-4.7288v-4.9498h11.737c11.014 0 11.744 0.019 11.857 0.30936 0.74999 1.9283 2.9227 9.0138 2.9227 9.5312 0 0.0324-5.9662 0.059-13.258 0.059h-13.258zm-37.029 4.3752c0.25036-1.1794 1.6747-5.9366 2.2627-7.5572l0.60931-1.6794 23.551-0.0909v9.902h-26.545zm-29.792 0.5171c0-0.45202 1.9827-5.4171 3.2419-8.1185l0.80344-1.7236h17.304l-0.5138 1.6352c-0.42404 1.3495-1.7096 6.3516-2.0218 7.8666l-0.082 0.39775h-9.3658c-5.1512 0-9.3658-0.0258-9.3658-0.0574zm3.1363 47.478c-0.54268-1.1424-1.1189-2.3953-1.2806-2.7842-0.38681-0.93076-1.8557-4.8554-1.8557-4.9581 0-0.044 4.2146-0.0801 9.3658-0.0801h9.3658l0.0893 0.39775c0.57947 2.58 1.26 5.2408 1.831 7.1594l0.69718 2.3423h-17.226zm34.694 32.471c-9.6578-3.8601-18.49-10.118-25.057-17.754l-1.6724-1.9446 7.3096-0.0462c4.0203-0.0254 7.3308 0.0172 7.3566 0.0946 0.0258 0.0774 0.65221 1.2517 1.392 2.6094 3.2072 5.8863 7.3567 11.648 11.557 16.047 0.99224 1.0393 1.6962 1.8867 1.5644 1.8832-0.1318-3e-3 -1.234-0.4038-2.4493-0.88956zm45.896-0.3857c4.5349-4.6445 9.2833-11.256 12.631-17.588l0.9576-1.811 14.614-0.00188-0.58096 0.73352c-5.1606 6.5158-13.389 13.016-21.457 16.95-2.3336 1.138-6.8193 2.999-7.2286 2.999-0.10293 0 0.37597-0.57674 1.0642-1.2816zm17.999-30.312c0.31804-0.82879 1.591-5.446 2.0265-7.3506l0.49303-2.156 18.783-0.0914-0.54523 1.5484c-0.69141 1.9635-1.6864 4.3601-2.7404 6.601l-0.82467 1.7532h-8.6543c-8.1176 0-8.647-0.0189-8.5374-0.30456zm-34.904-4.6452v-4.9498h26.483l-0.0907 0.39775c-0.30824 1.3512-1.7764 6.3086-2.3005 7.7676l-0.62286 1.7341h-23.469zm-34.207 4.6404c-0.63684-1.5564-2.3636-7.1473-2.8118-9.104l-0.11135-0.48613h26.523v9.8995h-11.737c-11.012 0-11.745-0.0191-11.863-0.30936zm21.428 29.374c-5.5182-4.3955-10.37-9.6816-14.359-15.644-0.81824-1.223-1.5387-2.3566-1.601-2.5191-0.10499-0.2736 0.55848-0.29535 9.0096-0.29535h9.1229v9.9879c0 5.4933-0.0601 9.9879-0.13355 9.9879-0.0734 0-0.99099-0.683-2.039-1.5178zm12.779-8.4701v-9.9879h18.242l-0.48627 0.83968c-2.549 4.4017-7.6854 10.616-12.018 14.54-2.0975 1.8997-5.3993 4.5963-5.6279 4.5963-0.0604 0-0.10975-4.4946-0.10975-9.9879z",
    display: "none",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.8897 0 0 .8897 92.216 121.3)",
    display: "inline"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "12.6 16.6 8.2 20.9 8.2 4.9 19.8 16.5 13 16.5",
    display: "inline",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "13.7 23.1 9 12 12.7 10.5 17.3 21.6",
    display: "inline",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.9221 -.3871 .3871 .9221 -5.7605 6.5909)",
    x: 12.5,
    y: 13.6,
    width: 2,
    height: 8,
    display: "inline"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.4 15.5 9.2 7.3 9.2 18.5 12.2 15.6 12.6 15.5",
    display: "inline"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.72734 0 0 .73504 39.194 58.001)",
    display: "none"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 45.668,
    y: 90.204,
    width: 89.614,
    height: 65.834,
    display: "inline",
    stroke: "#666",
    strokeWidth: 1.3229
  })), /*#__PURE__*/React.createElement("text", {
    x: 50.332035,
    y: 144.69685,
    fill: "#ffffff",
    fontFamily: "'Microsoft YaHei'",
    fontSize: "35.614px",
    letterSpacing: "0px",
    strokeWidth: 3.4203,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 0
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 50.332035,
    y: 144.69685,
    fill: "#ffffff",
    fontFamily: "'Microsoft YaHei'",
    fontSize: "35.614px",
    strokeWidth: 3.4203,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "&gt;")), /*#__PURE__*/React.createElement("text", {
    x: 71.721367,
    y: 135.56729,
    fill: "#ffffff",
    fontFamily: "'Microsoft YaHei'",
    fontSize: "35.614px",
    letterSpacing: "0px",
    strokeWidth: 1.3229,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 0
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 71.721367,
    y: 135.56729,
    fill: "#ffffff",
    fontFamily: "'Microsoft YaHei'",
    fontSize: "35.614px",
    strokeWidth: 1.3229,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "_"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4174 0 0 1.4174 -23.781 -28.306)",
    stroke: "#b3b3b3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.623,
    y: 108.06,
    width: 46.467,
    height: 33.365,
    fill: "url(#l)",
    strokeWidth: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.623 141.42v-10.454l12.498-14.092 12.087 14.027 11.206-9.4134 10.677 9.4195v10.513z",
    strokeWidth: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.729 114.82a1.9182 1.9182 0 0 1 1.9232-1.9131 1.9182 1.9182 0 0 1 1.9133 1.923 1.9182 1.9182 0 0 1-1.9228 1.9134 1.9182 1.9182 0 0 1-1.9136-1.9227",
    strokeWidth: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.623,
    y: 108.06,
    width: 46.467,
    height: 33.365,
    fill: "none",
    strokeWidth: 0.27
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4174 0 0 1.4174 -23.781 -28.306)",
    display: "none"
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m67.862 141.42 22.998-19.066 22.991 19.066zm-0.23923-33.365h46.467v33.365h-46.467z",
    display: "inline",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.26972
  })), /*#__PURE__*/React.createElement("path", {
    d: "m90.86 126.6c-2.2403 0-4.0565 1.8162-4.0565 4.0565 0 2.2404 1.8162 4.0565 4.0565 4.0565 0.60964 0 1.1865-0.13418 1.704-0.37407 0.25409-0.11779 0.55554-7e-3 0.67333 0.24679 0.11779 0.25404 0.0073 0.55549-0.24678 0.67327-0.64838 0.3006-1.3706 0.46813-2.1305 0.46813-2.8004 0-5.0706-2.2702-5.0706-5.0706 0-2.8004 2.2702-5.0706 5.0706-5.0706 2.8004 0 5.0706 2.2702 5.0706 5.0706l-8.4e-5 0.01c-0.02116 1.1104-0.37477 1.8583-0.89613 2.3225-0.50904 0.45326-1.1119 0.57679-1.5323 0.57679-0.60468 0-1.1355-0.31399-1.439-0.78778-1.053 0.93046-2.5708 1.135-3.508 0.0936-0.97652-1.085-0.70429-2.8966 0.33759-4.0543 1.008-1.12 2.841-1.5525 3.8933-0.25673 0.09046-0.24713 0.35783-0.38611 0.61496-0.31283 0.26935 0.0768 0.42543 0.3573 0.34871 0.62663-0.30028 1.0529-0.65467 2.0958-0.91946 3.1577 0.07712 0.29882 0.34916 0.51964 0.67196 0.51964 0.24288 0 0.58165-0.074 0.858-0.32006 0.26357-0.23466 0.5385-0.6865 0.55645-1.5796-0.0027-2.2381-1.8178-4.0517-4.0565-4.0517zm1.1932 4.52c0.03529-0.12174 0.12834-0.44693 0.23655-0.82555 0.11855-0.41529-0.03488-0.81421-0.35885-1.1742-0.46609-0.51788-1.4663-0.53402-2.2845 0.3751-0.82256 0.91399-0.85262 2.1252-0.33758 2.6975 0.46609 0.51786 1.4663 0.534 2.2845-0.37512 0.18913-0.21018 0.36727-0.42801 0.45991-0.69772z",
    clipRule: "evenodd",
    display: "inline",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.50706,
    style: {
      paintOrder: "stroke markers fill"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m67.814 108.06 23.045 22.949 23.039-22.949z",
    clipPath: "url(#s)",
    display: "inline",
    fill: "#fff",
    filter: "url(#m)",
    stroke: "#000",
    strokeWidth: 0.2705
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1073 0 0 1.1073 4.4537 8.653)",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m114.22 105.89-20.921 7.6058v42.545l20.965-11.542-0.0447-38.609",
    display: "inline",
    fill: "#808080",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.27,
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.346 103.02 25.951 10.469v42.545l-25.795-12.192z",
    display: "inline",
    fill: "#5b5b5b",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.27,
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.909 111.82v-15.262l25.309 9.3315-20.921 7.6058z",
    display: "inline",
    fill: "url(#i)",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.27,
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.909 96.556-21.563 6.4683 21.563 8.7933z",
    display: "inline",
    fill: "url(#h)",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.27,
    style: {
      paintOrder: "stroke markers fill"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m84.375 134.01c-0.06446 5e-3 -0.14063-0.0341-0.19728-0.10053-0.05665-0.0664-0.0841-0.1491-0.07105-0.21396l0.61956-3.0791c0.01108-0.0551 0.05001-0.09 0.10463-0.094 0.05468-4e-3 0.11852 0.0234 0.17191 0.0738l2.9809 2.8158c0.06283 0.0594 0.10131 0.14121 0.09951 0.21181-0.0017 0.0707-0.04343 0.11809-0.10778 0.12286l-0.22298 0.0164 1.0121 2.4897c0.22377 0.55031 0.19525 1.0813-0.07543 1.4053l-2.2177 2.6558c0.25015-0.51685 0.2344-1.2245-0.05743-1.9554l-2.82e-4 1e-3 -1.7759-4.369zm1.1573 6.2992c-0.43646 0.52403-1.2026 0.64112-2.0282 0.30989l-1.8507-0.7423c-0.13174-0.0529-0.25831-0.15597-0.3518-0.28665-0.09349-0.13068-0.14626-0.27822-0.14665-0.41012l-0.0079-2.4614c-4.5e-4 -0.13198 0.05158-0.23753 0.14457-0.29331 0.09298-0.0558 0.21938-0.0572 0.35113-4e-3l4.0104 1.6176c0.36136 0.88876 0.31569 1.7462-0.12083 2.2703zm-11.994-7.1322-0.0012-1e-3 4.0589 1.639 0.0016-0.29061c3.93e-4 -0.0712 0.04084-0.11993 0.10463-0.12611 0.06379-6e-3 0.14018 0.0314 0.19761 0.097l2.7256 3.1147c0.04877 0.0557 0.0774 0.12444 0.07707 0.18494-3.37e-4 0.0605-0.02959 0.10542-0.07881 0.12087l-2.7483 0.86691c-0.05788 0.0183-0.13433-7e-3 -0.19778-0.0654-0.06345-0.0584-0.10317-0.14005-0.10277-0.21128l0.0014-0.24654-2.3131-0.93406c-0.51128-0.20644-0.98683-0.66145-1.2589-1.2045l-2.2296-4.4495c0.44704 0.676 1.0849 1.2262 1.7636 1.5059zm0.34224-0.54081c-0.82561-0.33335-1.5938-1.0679-2.0339-1.9447-0.43995-0.87676-0.49007-1.7727-0.1327-2.3723l0.80148-1.3437c0.05704-0.0956 0.15891-0.14558 0.28323-0.13883 0.12432 7e-3 0.2609 0.0697 0.37959 0.17488l2.2152 1.9628c0.11875 0.10524 0.20993 0.24421 0.25347 0.38628 0.04348 0.14204 0.03566 0.27551-0.02166 0.37098zm6.0091-7.7009 0.0012-1.7e-4 -2.1561 2.5657 0.24577 0.25597c0.06019 0.0627 0.09377 0.14519 0.08691 0.21346-0.0069 0.0683-0.05304 0.11076-0.11948 0.1099l-3.1532-0.0396c-0.05642-6.9e-4 -0.12004-0.0326-0.17118-0.0859-0.05108-0.0533-0.08359-0.12144-0.08742-0.18346l-0.21342-3.467c-0.0045-0.0731 0.03139-0.12623 0.09282-0.13769 0.06148-0.0114 0.1381 0.0209 0.19829 0.0836l0.20842 0.21711 1.2288-1.462c0.27153-0.32317 0.74686-0.39365 1.2581-0.18662l4.1892 1.6966c-0.65686-0.15098-1.2434-4e-3 -1.6088 0.42014zm0.39298 0.81055c0.43854-0.52189 1.2059-0.63615 2.0316-0.30245 0.82567 0.33365 1.5937 1.0684 2.0336 1.9453l0.98576 1.9654c0.07015 0.1399 0.0931 0.28403 0.0639 0.40063-0.02931 0.11661-0.1084 0.19613-0.21989 0.22107l-2.0813 0.46526c-0.1116 0.0249-0.24655-7e-3 -0.37503-0.0883-0.12848-0.0815-0.24003-0.20594-0.31001-0.346z",
    display: "inline",
    fill: "#fff",
    strokeWidth: 0.056252
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m99.6 133.09c0.06446 8e-3 0.14063-0.0283 0.19728-0.0935 0.05665-0.065 0.0841-0.1481 0.07105-0.21479l-0.61956-3.1661c-0.01108-0.0566-0.05001-0.094-0.10463-0.1006-0.05468-7e-3 -0.11852 0.0185-0.17191 0.0674l-2.9809 2.7335c-0.06283 0.0576-0.10131 0.13929-0.09951 0.21132 0.0017 0.0721 0.04343 0.12232 0.10778 0.13011l0.22298 0.0268-1.0121 2.491c-0.22377 0.5506-0.19525 1.093 0.07543 1.4356l2.2177 2.8076c-0.25015-0.53811-0.2344-1.2585 0.05743-1.9901l2.82e-4 1e-3 1.7759-4.3713zm-1.1573 6.3665c0.43646 0.55393 1.2026 0.70819 2.0282 0.40829l1.8507-0.67205c0.13175-0.0478 0.25831-0.14716 0.3518-0.27607 0.0935-0.12891 0.14626-0.27686 0.14665-0.41125l8e-3 -2.5079c4.5e-4 -0.13448-0.0516-0.24441-0.14457-0.30549-0.093-0.0611-0.21939-0.0683-0.35113-0.0202l-4.0104 1.4656c-0.36136 0.88922-0.31569 1.7651 0.12083 2.3191zm11.994-6.7211 1e-3 -1e-3 -4.0589 1.4852-2e-3 -0.29622c-3.9e-4 -0.0726-0.0408-0.12408-0.10463-0.13328-0.0638-9e-3 -0.14018 0.0256-0.19761 0.0898l-2.7256 3.0498c-0.0488 0.0546-0.0774 0.12329-0.0771 0.18496 3.3e-4 0.0616 0.0296 0.10877 0.0788 0.12676l2.7483 1.0088c0.0579 0.0213 0.13433-9.9e-4 0.19778-0.0576 0.0635-0.0566 0.10317-0.13802 0.10277-0.21062l-1e-3 -0.25131 2.3131-0.84638c0.51127-0.18706 0.98683-0.62906 1.2589-1.17l2.2296-4.4327c-0.44704 0.6685-1.0849 1.2001-1.7636 1.4542zm-0.34224-0.56673c0.82562-0.30205 1.5938-1.0155 2.0339-1.889 0.43995-0.87342 0.49007-1.7842 0.1327-2.4115l-0.80148-1.4058c-0.057-0.10007-0.15891-0.1556-0.28323-0.15439-0.12432 1e-3 -0.2609 0.0591-0.37959 0.1609l-2.2152 1.8993c-0.11875 0.10183-0.20993 0.23929-0.25347 0.38208-0.0435 0.14276-0.0357 0.27913 0.0217 0.37905zm-6.0091-8.1217-1e-3 -2.3e-4 2.1562 2.7129-0.24577 0.24964c-0.0602 0.0611-0.0938 0.14368-0.0869 0.21356 7e-3 0.0699 0.053 0.1153 0.11948 0.11745l3.1532 0.10344c0.0564 2e-3 0.12005-0.0278 0.17118-0.0798 0.0511-0.0519 0.0836-0.11994 0.0874-0.18296l0.21343-3.5234c4e-3 -0.0743-0.0314-0.13007-0.0928-0.14455-0.0615-0.0144-0.1381 0.015-0.19829 0.0762l-0.20841 0.21174-1.2288-1.5459c-0.27153-0.34172-0.74687-0.43521-1.2581-0.24755l-4.1892 1.5379c0.65685-0.12391 1.2434 0.0528 1.6088 0.50151zm-0.39297 0.80808c-0.43855-0.55184-1.2059-0.70328-2.0316-0.40086-0.82567 0.30236-1.5937 1.0161-2.0336 1.8896l-0.98576 1.958c-0.07015 0.13937-0.0931 0.28521-0.0639 0.40536 0.02931 0.12017 0.1084 0.20481 0.21989 0.23531l2.0813 0.56904c0.1116 0.0305 0.24655 4e-3 0.37503-0.0728 0.12848-0.0771 0.24003-0.19892 0.31001-0.33846z",
    display: "inline",
    fill: "#fff",
    strokeWidth: 0.056786
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.196 25.379)",
    display: "none"
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(.32869)",
    d: "m96.716 90.214 0.01027 15.856h-0.1556 17.178m-46.575 49.968v-65.834h29.527l17.045 15.859 0.0332 49.975z",
    display: "inline",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.31121
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m100.27 130.84v12.154c-1.2312-0.18877-2.6467-0.0944-4.0802 0.33512-3.613 1.0826-5.9674 3.8774-5.2587 6.2422 0.70864 2.3649 4.212 3.4043 7.825 2.3217 3.613-1.0826 5.9674-3.8774 5.2588-6.2422v-12.635c0.0326-0.0118 0.0774-0.0243 0.13709-0.0361 1.5962-0.31025 3.2727 0.43748 4.3023 1.65 1.0781 1.2696 1.5923 2.8375 1.9769 4.4294l0.0137 0.0573c0.081 0.33166 0.35843 0.59541 0.71723 0.64191 0.46568 0.0604 0.89211-0.268 0.95288-0.73357 0.28116-2.1566 0.28991-4.3321-0.49434-6.3945-0.72224-1.8991-2.0496-3.5159-3.7631-4.6071-1.0572-0.67334-2.2619-1.1987-3.503-1.4086-0.0428-7e-3 -0.0806-0.0127-0.11323-0.0178-0.0493-5e-3 -0.0908-9e-3 -0.12421-0.0126-0.0172-2e-3 -0.0324-3e-3 -0.0455-4e-3 -5e-3 -1e-3 -0.01-1e-3 -0.0133-2e-3 -6e-3 -1e-3 -0.01-1e-3 -0.01-1e-3 -0.0113-2e-3 -0.0229-4e-3 -0.0342-6e-3v-0.92032c1.3e-4 -1.034-0.83815-1.8723-1.8723-1.8723s-1.8723 0.83831-1.8723 1.8723z",
    display: "inline"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m92.394 97.283-13.494 3.3734c-0.36511 0.0913-0.63854 0.43366-0.63854 0.81811v15.58c-0.70572-0.42553-1.5803-0.68103-2.53-0.68103-2.3253 0-4.2168 1.5132-4.2168 3.3734 0 1.8602 1.8915 3.3734 4.2168 3.3734s4.2168-1.5132 4.2168-3.3734v-12.554l11.807-2.9517v7.7534c-0.70576-0.42558-1.5803-0.68112-2.5301-0.68112-2.3253 0-4.2168 1.5132-4.2168 3.3734 0 1.8602 1.8916 3.3734 4.2168 3.3734 2.3253 0 4.2168-1.5132 4.2168-3.3734v-16.586c0-0.53912-0.51125-0.95055-1.0482-0.81811z",
    display: "inline"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m367.7 371.52v-28.527l0.97227 0.90007c11.602 10.74 57.93 53.797 58.95 54.787l1.409 1.3678h-61.331z",
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.36079,
    style: {
      paintOrder: "stroke markers fill"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.8091 0 0 1.8481 76.959 116.64)",
    display: "none",
    fillRule: "evenodd"
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m15.516 34.487c-15.93-6.172-14.484-27.2-14.484-27.2 9.643 1.778 14.484-6.8 14.484-6.8s4.83 8.578 14.452 6.8c0 0 1.443 21.028-14.452 27.2z",
    display: "inline",
    fill: "url(#g)",
    stroke: "#000"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m15.105 9.9713-0.35512 0.044336c-1.3428 0.16768-2.6079 0.72232-3.641 1.5963l-1.0771 0.91114 3.8878 7.0371 1.0771-0.91112c1.0332-0.874 2.2982-1.4286 3.641-1.5963 1.4552-0.18176 2.816-0.81739 3.8893-1.8167l0.06071-0.05653c0.35548-0.33097 0.29014-0.91127-0.12997-1.155l-2.1095-1.2237c-0.46159-0.26773-0.69242-0.40159-0.84127-0.60367-0.06202-0.08434-0.11284-0.17637-0.15124-0.27376-0.09186-0.23357-0.08229-0.50024-0.06326-1.0335l0.07123-1.9966c0.01864-0.52256-0.60382-0.80682-0.98654-0.45048-0.90298 0.84075-2.0479 1.3756-3.2722 1.5284z",
    display: "inline",
    fill: "#f9f9f9",
    stroke: "#000",
    strokeWidth: 0.1136
  })), /*#__PURE__*/React.createElement("text", {
    x: 7.9401855,
    y: 28.776844,
    clipPath: "url(#b)",
    display: "inline",
    fill: "#000080",
    fillRule: "evenodd",
    fontFamily: "Haettenschweiler",
    fontSize: "14.51px",
    letterSpacing: "0px",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeWidth: 0.11001,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 0,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.9401855,
    y: 28.776844,
    fill: "#000080",
    fontFamily: "Haettenschweiler",
    fontSize: "14.51px",
    stroke: "#000000",
    strokeWidth: 0.11001,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "CTF")), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m9.3129 11.221c-0.16104-0.29148-0.52789-0.39723-0.81937-0.2362-0.29148 0.16104-0.39723 0.52789-0.23619 0.81938l7.7757 14.074c0.16104 0.29148 0.52789 0.39724 0.81937 0.2362 0.29148-0.16104 0.39723-0.52789 0.2362-0.81937l-7.0565-12.772z",
    clipRule: "evenodd",
    display: "inline",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.1136
  })), /*#__PURE__*/React.createElement("text", {
    x: 7.9401855,
    y: 28.776844,
    clipPath: "url(#r)",
    display: "inline",
    fill: "#000080",
    fontFamily: "Haettenschweiler",
    fontSize: "14.51px",
    letterSpacing: "0px",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeWidth: 0.11001,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 0,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.9401855,
    y: 28.776844,
    fill: "#000080",
    fontFamily: "Haettenschweiler",
    fontSize: "14.51px",
    stroke: "#000000",
    strokeWidth: 0.11001,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "CTF")), /*#__PURE__*/React.createElement("text", {
    x: 7.9401855,
    y: 28.776844,
    clipPath: "url(#q)",
    display: "inline",
    fill: "#000080",
    fontFamily: "Haettenschweiler",
    fontSize: "14.51px",
    letterSpacing: "0px",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeWidth: 0.11001,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 0,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.9401855,
    y: 28.776844,
    fill: "#000080",
    fontFamily: "Haettenschweiler",
    fontSize: "14.51px",
    stroke: "#000000",
    strokeWidth: 0.11001,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "CTF")), /*#__PURE__*/React.createElement("path", {
    d: "m10.76 18.525c-1.7193 0-2.5791 0.6588-2.5791 1.9766v6.5394c0 1.2186 0.85977 1.8281 2.5791 1.8281 0.59514 0 1.1287-0.14416 1.601-0.43229 0.47234-0.29285 0.70868-0.68031 0.70868-1.1621v-2.5789h-2.0335v2.5082c0 0.16532-0.10168 0.24802-0.30478 0.24802-0.21255 0-0.31878-0.0827-0.31878-0.24802v-7.0497c0-0.16532 0.10623-0.24774 0.31878-0.24774 0.2031 0 0.30478 0.08242 0.30478 0.24774v2.0121h2.0335v-1.8421c0-1.1997-0.76989-1.7993-2.3097-1.7993zm7.8783 0.09199v10.16h2.232v-4.8746h1.7427v-1.2328h-1.7427v-2.7416h1.9484v-1.3108zm-5.1507 0.04306v1.2818h0.71039z",
    clipPath: "url(#b)",
    display: "inline",
    fill: "#000080",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.11001,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.16 19.942h0.15025l-0.56157-1.305-0.21054 0.23315z",
    fill: "#000080",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeWidth: 0.2894,
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.488 18.858 0.13054-0.03188 0.13083-0.18958-0.21938-0.02013h-0.04113l-9.29e-4 0.04333z",
    fill: "#000080",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeWidth: 0.2894,
    style: {
      paintOrder: "stroke markers fill"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.524 25.379)",
    display: "none"
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m96.716 90.214 0.01027 15.856h-0.1556 17.178m-46.575 49.968v-65.834h29.527l17.045 15.859 0.0332 49.975z",
    display: "inline",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.31121
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m96.919 98.302v-7.5852l0.33451 0.3132c0.18398 0.17241 3.6924 3.4298 7.7966 7.2391 4.1041 3.8092 7.6234 7.0816 7.8206 7.272l0.35852 0.34615h-16.31z",
    display: "inline",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-10.07 13.345)",
    d: "m80.289 130.63v-0.44834h1.2851v0.44834zm2.3264 0v-0.44834h1.2851v0.44834zm2.9566 0.13842q0.08677 0 0.16115 0.0331 0.07438 0.031 0.1281 0.0868 0.05578 0.0537 0.08678 0.12809 0.03099 0.0744 0.03099 0.15909 0 0.0826-0.03099 0.15702-0.03099 0.0723-0.08678 0.1281-0.05372 0.0537-0.1281 0.0847-0.07438 0.0331-0.16115 0.0331-0.08264 0-0.15496-0.0331-0.07231-0.031-0.12603-0.0847-0.05372-0.0558-0.08471-0.1281-0.03099-0.0744-0.03099-0.15702 0-0.0847 0.03099-0.15909 0.03099-0.0744 0.08471-0.12809 0.05372-0.0558 0.12603-0.0868 0.07231-0.0331 0.15496-0.0331zm4.6528 0q0.08678 0 0.16115 0.0331 0.07438 0.031 0.1281 0.0868 0.05578 0.0537 0.08678 0.12809 0.03099 0.0744 0.03099 0.15909 0 0.0826-0.03099 0.15702-0.03099 0.0723-0.08678 0.1281-0.05372 0.0537-0.1281 0.0847-0.07438 0.0331-0.16115 0.0331-0.08264 0-0.15496-0.0331-0.07231-0.031-0.12603-0.0847-0.05372-0.0558-0.08471-0.1281-0.03099-0.0744-0.03099-0.15702 0-0.0847 0.03099-0.15909 0.03099-0.0744 0.08471-0.12809 0.05372-0.0558 0.12603-0.0868 0.07231-0.0331 0.15496-0.0331zm1.6962-0.13842v-0.44834h1.2851v0.44834zm2.9566 0.13842q0.08678 0 0.16115 0.0331 0.07438 0.031 0.1281 0.0868 0.05578 0.0537 0.08678 0.12809 0.03099 0.0744 0.03099 0.15909 0 0.0826-0.03099 0.15702-0.03099 0.0723-0.08678 0.1281-0.05372 0.0537-0.1281 0.0847-0.07438 0.0331-0.16115 0.0331-0.08264 0-0.15496-0.0331-0.07231-0.031-0.12603-0.0847-0.05372-0.0558-0.08471-0.1281-0.03099-0.0744-0.03099-0.15702 0-0.0847 0.03099-0.15909 0.03099-0.0744 0.08471-0.12809 0.05372-0.0558 0.12603-0.0868 0.07231-0.0331 0.15496-0.0331zm4.6528 0q0.08678 0 0.16115 0.0331 0.07438 0.031 0.1281 0.0868 0.05578 0.0537 0.08678 0.12809 0.03099 0.0744 0.03099 0.15909 0 0.0826-0.03099 0.15702-0.03099 0.0723-0.08678 0.1281-0.05372 0.0537-0.1281 0.0847-0.07438 0.0331-0.16115 0.0331-0.08264 0-0.15496-0.0331-0.07231-0.031-0.12603-0.0847-0.05372-0.0558-0.08471-0.1281-0.03099-0.0744-0.03099-0.15702 0-0.0847 0.03099-0.15909 0.03099-0.0744 0.08471-0.12809 0.05372-0.0558 0.12603-0.0868 0.07231-0.0331 0.15496-0.0331zm4.6528 0q0.0868 0 0.16116 0.0331 0.0744 0.031 0.1281 0.0868 0.0558 0.0537 0.0868 0.12809 0.031 0.0744 0.031 0.15909 0 0.0826-0.031 0.15702-0.031 0.0723-0.0868 0.1281-0.0537 0.0537-0.1281 0.0847-0.0744 0.0331-0.16116 0.0331-0.0826 0-0.15495-0.0331-0.0723-0.031-0.12603-0.0847-0.0537-0.0558-0.0847-0.1281-0.031-0.0744-0.031-0.15702 0-0.0847 0.031-0.15909 0.031-0.0744 0.0847-0.12809 0.0537-0.0558 0.12603-0.0868 0.0723-0.0331 0.15495-0.0331zm1.6963-0.13842v-0.44834h1.2851v0.44834zm4.6528 0v-0.44834h1.2851v0.44834zm-29.847-14.793q0.08678 0 0.16115 0.0331 0.07438 0.031 0.1281 0.0868 0.05578 0.0537 0.08677 0.1281t0.03099 0.15909q0 0.0826-0.03099 0.15702-0.03099 0.0723-0.08677 0.1281-0.05372 0.0537-0.1281 0.0847-0.07438 0.0331-0.16115 0.0331-0.08264 0-0.15496-0.0331-0.07231-0.031-0.12603-0.0847-0.05372-0.0558-0.08471-0.1281-0.03099-0.0744-0.03099-0.15702 0-0.0847 0.03099-0.15909 0.03099-0.0744 0.08471-0.1281 0.05372-0.0558 0.12603-0.0868 0.07231-0.0331 0.15496-0.0331zm2.3264 0q0.08678 0 0.16115 0.0331 0.07438 0.031 0.1281 0.0868 0.05578 0.0537 0.08678 0.1281 0.03099 0.0744 0.03099 0.15909 0 0.0826-0.03099 0.15702-0.03099 0.0723-0.08678 0.1281-0.05372 0.0537-0.1281 0.0847-0.07438 0.0331-0.16115 0.0331-0.08264 0-0.15496-0.0331-0.07231-0.031-0.12603-0.0847-0.05372-0.0558-0.08471-0.1281-0.03099-0.0744-0.03099-0.15702 0-0.0847 0.03099-0.15909 0.03099-0.0744 0.08471-0.1281 0.05372-0.0558 0.12603-0.0868 0.07231-0.0331 0.15496-0.0331zm4.6528 0q0.08678 0 0.16115 0.0331 0.07438 0.031 0.1281 0.0868 0.05578 0.0537 0.08678 0.1281 0.03099 0.0744 0.03099 0.15909 0 0.0826-0.03099 0.15702-0.03099 0.0723-0.08678 0.1281-0.05372 0.0537-0.1281 0.0847-0.07438 0.0331-0.16115 0.0331-0.08264 0-0.15496-0.0331-0.07231-0.031-0.12603-0.0847-0.05372-0.0558-0.08471-0.1281-0.03099-0.0744-0.03099-0.15702 0-0.0847 0.03099-0.15909 0.03099-0.0744 0.08471-0.1281 0.05372-0.0558 0.12603-0.0868 0.07231-0.0331 0.15496-0.0331zm2.3264 0q0.08678 0 0.16115 0.0331 0.07438 0.031 0.1281 0.0868 0.05578 0.0537 0.08678 0.1281 0.03099 0.0744 0.03099 0.15909 0 0.0826-0.03099 0.15702-0.03099 0.0723-0.08678 0.1281-0.05372 0.0537-0.1281 0.0847-0.07438 0.0331-0.16115 0.0331-0.08264 0-0.15496-0.0331-0.07231-0.031-0.12603-0.0847-0.05372-0.0558-0.08471-0.1281-0.03099-0.0744-0.03099-0.15702 0-0.0847 0.03099-0.15909 0.03099-0.0744 0.08471-0.1281 0.05372-0.0558 0.12603-0.0868 0.07231-0.0331 0.15496-0.0331zm2.3264 0q0.08678 0 0.16116 0.0331 0.07438 0.031 0.1281 0.0868 0.05579 0.0537 0.08678 0.1281t0.03099 0.15909q0 0.0826-0.03099 0.15702-0.03099 0.0723-0.08678 0.1281-0.05372 0.0537-0.1281 0.0847-0.07438 0.0331-0.16116 0.0331-0.08264 0-0.15496-0.0331-0.07231-0.031-0.12603-0.0847-0.05372-0.0558-0.08471-0.1281-0.03099-0.0744-0.03099-0.15702 0-0.0847 0.03099-0.15909 0.03099-0.0744 0.08471-0.1281 0.05372-0.0558 0.12603-0.0868 0.07231-0.0331 0.15496-0.0331zm-12.029-14.484v-0.44834h1.2851v0.44834zm2.9566 0.13843q0.08678 0 0.16115 0.0331 0.07438 0.031 0.1281 0.0868 0.05578 0.0537 0.08677 0.1281t0.03099 0.15909q0 0.0826-0.03099 0.15702-0.03099 0.0723-0.08677 0.1281-0.05372 0.0537-0.1281 0.0847-0.07438 0.033-0.16115 0.033-0.08264 0-0.15496-0.033-0.07231-0.031-0.12603-0.0847-0.05372-0.0558-0.08471-0.1281-0.03099-0.0744-0.03099-0.15702 0-0.0847 0.03099-0.15909 0.03099-0.0744 0.08471-0.1281 0.05372-0.0558 0.12603-0.0868 0.07231-0.0331 0.15496-0.0331zm2.3264 0q0.08677 0 0.16115 0.0331 0.07438 0.031 0.1281 0.0868 0.05578 0.0537 0.08678 0.1281 0.03099 0.0744 0.03099 0.15909 0 0.0826-0.03099 0.15702-0.03099 0.0723-0.08678 0.1281-0.05372 0.0537-0.1281 0.0847-0.07438 0.033-0.16115 0.033-0.08264 0-0.15496-0.033-0.07231-0.031-0.12603-0.0847-0.05372-0.0558-0.08471-0.1281-0.03099-0.0744-0.03099-0.15702 0-0.0847 0.03099-0.15909 0.03099-0.0744 0.08471-0.1281 0.05372-0.0558 0.12603-0.0868 0.07231-0.0331 0.15496-0.0331zm2.3264 0q0.08678 0 0.16115 0.0331 0.07438 0.031 0.1281 0.0868 0.05578 0.0537 0.08678 0.1281 0.03099 0.0744 0.03099 0.15909 0 0.0826-0.03099 0.15702-0.03099 0.0723-0.08678 0.1281-0.05372 0.0537-0.1281 0.0847-0.07438 0.033-0.16115 0.033-0.08264 0-0.15496-0.033-0.07231-0.031-0.12603-0.0847-0.05372-0.0558-0.08471-0.1281-0.03099-0.0744-0.03099-0.15702 0-0.0847 0.03099-0.15909 0.03099-0.0744 0.08471-0.1281 0.05372-0.0558 0.12603-0.0868 0.07231-0.0331 0.15496-0.0331zm4.0227-0.13843v-0.44834h1.2851v0.44834zm2.3264 0v-0.44834h1.2851v0.44834zm2.3264 0v-0.44834h1.2851v0.44834zm5.283 0.13843q0.0868 0 0.16115 0.0331 0.0744 0.031 0.1281 0.0868 0.0558 0.0537 0.0868 0.1281t0.031 0.15909q0 0.0826-0.031 0.15702-0.031 0.0723-0.0868 0.1281-0.0537 0.0537-0.1281 0.0847-0.0744 0.033-0.16115 0.033-0.0826 0-0.15496-0.033-0.0723-0.031-0.12603-0.0847-0.0537-0.0558-0.0847-0.1281-0.031-0.0744-0.031-0.15702 0-0.0847 0.031-0.15909 0.031-0.0744 0.0847-0.1281 0.0537-0.0558 0.12603-0.0868 0.0723-0.0331 0.15496-0.0331zm2.3264 0q0.0868 0 0.16116 0.0331 0.0744 0.031 0.1281 0.0868 0.0558 0.0537 0.0868 0.1281t0.031 0.15909q0 0.0826-0.031 0.15702-0.031 0.0723-0.0868 0.1281-0.0537 0.0537-0.1281 0.0847-0.0744 0.033-0.16116 0.033-0.0826 0-0.15495-0.033-0.0723-0.031-0.12603-0.0847-0.0537-0.0558-0.0847-0.1281-0.031-0.0744-0.031-0.15702 0-0.0847 0.031-0.15909 0.031-0.0744 0.0847-0.1281 0.0537-0.0558 0.12603-0.0868 0.0723-0.0331 0.15495-0.0331zm1.6963-0.13843v-0.44834h1.2851v0.44834zm4.6528 0v-0.44834h1.2851v0.44834zm5.283 0.13843q0.0868 0 0.16116 0.0331 0.0744 0.031 0.12809 0.0868 0.0558 0.0537 0.0868 0.1281t0.031 0.15909q0 0.0826-0.031 0.15702-0.031 0.0723-0.0868 0.1281-0.0537 0.0537-0.12809 0.0847-0.0744 0.033-0.16116 0.033-0.0826 0-0.15495-0.033-0.0723-0.031-0.12604-0.0847-0.0537-0.0558-0.0847-0.1281-0.031-0.0744-0.031-0.15702 0-0.0847 0.031-0.15909 0.031-0.0744 0.0847-0.1281 0.0537-0.0558 0.12604-0.0868 0.0723-0.0331 0.15495-0.0331zm1.6962-0.13843v-0.44834h1.2851v0.44834zm-36.826-14.793q0.08678 0 0.16115 0.03306 0.07438 0.03099 0.1281 0.08678 0.05578 0.05372 0.08677 0.1281 0.03099 0.07438 0.03099 0.15909 0 0.08264-0.03099 0.15702-0.03099 0.07231-0.08677 0.1281-0.05372 0.05372-0.1281 0.08471-0.07438 0.03306-0.16115 0.03306-0.08264 0-0.15496-0.03306-0.07231-0.03099-0.12603-0.08471-0.05372-0.05578-0.08471-0.1281-0.03099-0.07438-0.03099-0.15702 0-0.08471 0.03099-0.15909 0.03099-0.07438 0.08471-0.1281 0.05372-0.05578 0.12603-0.08678 0.07231-0.03306 0.15496-0.03306zm1.6963-0.13843v-0.44834h1.2851v0.44834zm5.283 0.13843q0.08678 0 0.16115 0.03306 0.07438 0.03099 0.1281 0.08678 0.05578 0.05372 0.08678 0.1281 0.03099 0.07438 0.03099 0.15909 0 0.08264-0.03099 0.15702-0.03099 0.07231-0.08678 0.1281-0.05372 0.05372-0.1281 0.08471-0.07438 0.03306-0.16115 0.03306-0.08264 0-0.15496-0.03306-0.07231-0.03099-0.12603-0.08471-0.05372-0.05578-0.08471-0.1281-0.03099-0.07438-0.03099-0.15702 0-0.08471 0.03099-0.15909 0.03099-0.07438 0.08471-0.1281 0.05372-0.05578 0.12603-0.08678 0.07231-0.03306 0.15496-0.03306zm1.6963-0.13843v-0.44834h1.2851v0.44834zm2.9566 0.13843q0.08678 0 0.16116 0.03306 0.07438 0.03099 0.1281 0.08678 0.05579 0.05372 0.08678 0.1281 0.03099 0.07438 0.03099 0.15909 0 0.08264-0.03099 0.15702-0.03099 0.07231-0.08678 0.1281-0.05372 0.05372-0.1281 0.08471-0.07438 0.03306-0.16116 0.03306-0.08264 0-0.15496-0.03306-0.07231-0.03099-0.12603-0.08471-0.05372-0.05578-0.08471-0.1281-0.03099-0.07438-0.03099-0.15702 0-0.08471 0.03099-0.15909 0.03099-0.07438 0.08471-0.1281 0.05372-0.05578 0.12603-0.08678 0.07231-0.03306 0.15496-0.03306zm2.3264 0q0.08677 0 0.16115 0.03306 0.07438 0.03099 0.1281 0.08678 0.05578 0.05372 0.08678 0.1281 0.03099 0.07438 0.03099 0.15909 0 0.08264-0.03099 0.15702-0.03099 0.07231-0.08678 0.1281-0.05372 0.05372-0.1281 0.08471-0.07438 0.03306-0.16115 0.03306-0.08264 0-0.15496-0.03306-0.07231-0.03099-0.12603-0.08471-0.05372-0.05578-0.08471-0.1281-0.03099-0.07438-0.03099-0.15702 0-0.08471 0.03099-0.15909 0.03099-0.07438 0.08471-0.1281 0.05372-0.05578 0.12603-0.08678 0.07231-0.03306 0.15496-0.03306zm4.6528 0q0.08678 0 0.16115 0.03306 0.07438 0.03099 0.1281 0.08678 0.05578 0.05372 0.08678 0.1281 0.03099 0.07438 0.03099 0.15909 0 0.08264-0.03099 0.15702-0.03099 0.07231-0.08678 0.1281-0.05372 0.05372-0.1281 0.08471-0.07438 0.03306-0.16115 0.03306-0.08264 0-0.15496-0.03306-0.07231-0.03099-0.12603-0.08471-0.05372-0.05578-0.08471-0.1281-0.03099-0.07438-0.03099-0.15702 0-0.08471 0.03099-0.15909 0.03099-0.07438 0.08471-0.1281 0.05372-0.05578 0.12603-0.08678 0.07231-0.03306 0.15496-0.03306zm2.3264 0q0.0868 0 0.16116 0.03306 0.0744 0.03099 0.12809 0.08678 0.0558 0.05372 0.0868 0.1281 0.031 0.07438 0.031 0.15909 0 0.08264-0.031 0.15702-0.031 0.07231-0.0868 0.1281-0.0537 0.05372-0.12809 0.08471-0.0744 0.03306-0.16116 0.03306-0.0826 0-0.15495-0.03306-0.0723-0.03099-0.12603-0.08471-0.0537-0.05578-0.0847-0.1281-0.031-0.07438-0.031-0.15702 0-0.08471 0.031-0.15909 0.031-0.07438 0.0847-0.1281 0.0537-0.05578 0.12603-0.08678 0.0723-0.03306 0.15495-0.03306z",
    display: "inline",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.39669,
    style: {
      paintOrder: "stroke markers fill"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1.002 5e-7 -.59746)",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 179.11,
    width: 210,
    height: 117.89,
    display: "inline",
    fill: "#0078d7",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeWidth: 0.52917,
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 19.792027,
    y: 214.80887,
    display: "inline",
    fill: "#ffffff",
    fillRule: "evenodd",
    fontFamily: "Aldhabi",
    fontSize: "37.306px",
    letterSpacing: "0px",
    strokeLinejoin: "round",
    strokeWidth: 3.4974,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 19.792027,
    y: 214.80887,
    fill: "#ffffff",
    fontFamily: "Aldhabi",
    fontSize: "37.306px",
    strokeWidth: 3.4974,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, ":(")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.031019 0 0 .031019 20.432 198.14)",
    x: 4948.4131,
    display: "inline",
    fill: "#ffffff",
    fillRule: "evenodd",
    fontFamily: "Arial",
    fontSize: "157.97px",
    letterSpacing: "0px",
    strokeLinejoin: "round",
    strokeWidth: 2,
    wordSpacing: "-.026151px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 0,
      paintOrder: "stroke markers fill",
      shapeInside: "url(#rect6)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 79.96875,
    y: 974.02504
  }, /*#__PURE__*/React.createElement("tspan", {
    dx: "0 0 0 0 0.026166558 -0.026161194 0 0.026174188 -0.026191711 0 0 0.026151299 -0.026130676 0 0 0 0.026151299 -0.026191711 0.026151299 -0.026191711 0 0 0 0 0 0 0.026059747 -0.026069641 0 0 0.026029229 -0.025947571 -0.00012207031 0.00012207031 -0.00012207031 0.00012207031 0.025975823 -0.026191711 0.00017547607 0.026029229 -0.026191711 0.00019836426 -0.00012207031 0 0 0.00012207031 0 0 0.026082635 -0.026191711 0 0.00012207031 0 0 0.026029229",
    style: {
      lineHeight: 1.1
    }
  }, "Your PC ran into a problem and needs to restart. We're ")), /*#__PURE__*/React.createElement("tspan", {
    x: 79.96875,
    y: 1147.7954
  }, /*#__PURE__*/React.createElement("tspan", {
    dx: "0 0 0 0 0.026158929 -0.026145935 0 0 0 0 0 0 0 0 0 0.026151299 -0.026191711 0 0 0 0.026151299 -0.026191711 0 0 0 0 0.026105523 -0.026069641 -0.00010681152 0 0 0.00012207031 0.026082635 -0.026191711 -0.00012207031 0.00012207031",
    style: {
      lineHeight: 1.1
    }
  }, "just collecting some error info, and"), /*#__PURE__*/React.createElement("tspan", {
    dx: "0.026029229 -0.026191711 0 0.00012207031 -0.00012207031 0.026029229 -0.026191711 0 0.00012207031 0 -0.00010681152 0.026288629 -0.026191711 0 0.00012207031 -0.00017547607 0.00017547607 -0.00012207031 0 0.026082635 -0.026191711 0.00017547607 -0.00012207031 0.026349664",
    "text-align": "justify",
    style: {
      lineHeight: 0.9
    }
  }, " then we'll restart for ")), /*#__PURE__*/React.createElement("tspan", {
    x: 79.96875,
    y: 1305.7684
  }, /*#__PURE__*/React.createElement("tspan", {
    "text-align": "justify",
    style: {
      lineHeight: 0.9
    }
  }, "you."))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.76201 0 0 .76048 48.934 71.344)",
    display: "inline"
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m-32.973 258.12v-1.5797h1.5797v1.5797zm-1.0531 1.0531v-3.6859h3.6859v3.6859zm0.52655-0.52655h2.6328v-2.6328h-2.6328zm13.69-13.69v1.5797h-1.5797v-1.5797zm1.0531-1.0531v3.6859h-3.6859v-3.6859zm-0.52655 0.52655h-2.6328v2.6328h2.6328zm-13.69 0.52655h1.5797v1.5797h-1.5797zm-1.0531-1.0531h3.6859v3.6859h-3.6859zm0.52655 0.52655v2.6328h2.6328v-2.6328z",
    display: "inline",
    fill: "#fff",
    strokeWidth: 0.52655
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m-27.708 243.9v0.52656h-0.52655v1.0531h-0.52655v-1.0531h-0.52655v0.52654h-0.52655v3.1593h0.52655v1.0531h-0.52655v-0.52656h-0.52655v-0.52655h-2.6328v0.52655h-0.52655v-0.52655h-0.52655v0.52655h0.52655v0.52656h-0.52655v0.52655h0.52655v1.0531h1.0531v0.52656h-1.0531v1.0531h-0.52655v2.6328h0.52655v-2.1062h0.52655v0.52655h0.52655v0.52655h0.52655v0.52656h1.0531v0.52654h1.0531v0.52656h0.52655v0.52656h-0.52655v2.1062h1.5797v0.52655h-0.52655v0.52656h0.52655v-0.52656h0.52655v0.52656h0.52655v-1.0531h-0.52655v-1.0531h0.52655v0.52655h0.52655v1.0531h0.52655v0.52656h0.52655v-1.0531h0.52655v0.52655h1.5797v-1.0531h0.52655v0.52655h0.52655v-1.0531h0.52655v1.0531h0.52655v-1.0531h0.52655v-1.0531h0.52655v1.0531h1.5797v-1.0531h-1.0531v-0.52656h0.52655v-1.0531h-1.5797v-0.52656h2.1062v-1.0531h-1.0531v0.52655h-0.52655v-0.52655h-1.5797v-0.52655h1.0531v-0.52656h1.0531v0.52656h1.0531v-1.0531h-0.52655v-0.52656h-0.52655v0.52656h-0.52655v-0.52656h-0.52655v-0.52655h0.52655v-0.52655h0.52655v-0.52655h0.52655v-0.52656h-0.52655v-0.52655h-2.6328v0.52655h0.52655v0.52656h1.0531v0.52655h-1.5797v0.52655h0.52655v0.52655h-0.52655v0.52656h-0.52655v-2.1062h-0.52655v0.52655h-0.52655v-0.52655h-1.5797v-0.52656h0.52655v-1.5797h0.52655v0.52656h0.52655v0.52655h0.52655v-0.52655h0.52655v-0.52656h-0.52655v-0.52655h0.52655v-1.5797h-0.52655v-0.52654h0.52655v-0.52656h-0.52655v0.52656h-0.52655v1.0531h0.52655v0.52655h-0.52655v0.52655h-1.0531v-0.52655h0.52655v-0.52655h-0.52655v0.52655h-0.52655v-1.0531h0.52655v-0.52654h-0.52655v-0.52656zm1.0531 1.0531v0.52656h-1.0531v0.52655h-1.5797v1.5797h0.52655v-0.52656h0.52655v0.52656h0.52655v1.0531h2.1062v-1.5797h0.52655v-0.52655h-1.0531v-0.52655h-0.52655v-0.52655h0.52655v-0.52656zm-1.0531 1.0531v0.52655h0.52655v-0.52655zm0 1.0531v0.52656h0.52655v-0.52656zm1.0531 0v1.0531h0.52655v-1.0531zm2.6328 0v0.52656h0.52655v-0.52656zm-4.739 1.0531v0.52655h0.52655v-0.52655zm-3.6859 0.52655v0.52656h0.52655v1.0531h-0.52655v-0.52655h-0.52655v-0.52655h-0.52655v0.52655h0.52655v0.52655h0.52655v0.52655h1.0531v-0.52655h1.5797v1.0531h-0.52655v-0.52656h-0.52655v0.52656h-1.5797v1.0531h2.6328v1.5796h-1.0531v-0.52655h0.52655v-0.52655h-0.52655v0.52655h-0.52655v-0.52655h-1.0531v0.52655h0.52655v0.52655h1.0531v0.52656h1.0531v0.52654h0.52655v0.52656h0.52655v-0.52656h0.52655v0.52656h0.52655v-1.0531h-1.0531v0.52654h-0.52655v-0.52654h-0.52655v-0.52656h2.1062v-0.52655h0.52655v-0.52655h1.5797v0.52655h1.5797v0.52655h-1.5797v1.0531h0.52655v0.52656h-1.0531v-0.52656h-0.52655v-0.52654h0.52655v-0.52656h-0.52655v0.52656h-0.52655v1.5797h-1.0531v0.52654h-0.52655v1.0531h0.52655v-0.52655h0.52655v-0.52656h0.52655v0.52656h1.5797v0.52655h0.52655v-0.52655h0.52655v-2.1062h-0.52655v-0.52654h1.0531v0.52654h0.52655v-0.52654h-0.52655v-0.52656h1.0531v0.52656h0.52655v-0.52656h0.52655v-0.52655h-1.5797v-1.0531h0.52655v0.52655h0.52655v-0.52655h-0.52655v-1.0531h-0.52655v1.0531h-0.52655v0.52655h-1.5797v-1.0531h0.52655v0.52656h0.52655v-0.52656h0.52655v-0.52654h-0.52655v-1.0531h0.52655v0.52655h0.52655v-0.52655h-0.52655v-0.52655h-0.52655v0.52655h-0.52655v-0.52655h-0.52655v1.0531h0.52655v0.52656h-1.0531v-0.52656h-0.52655v-0.52655h0.52655v-0.52655h-0.52655v0.52655h-1.0531v-0.52655h0.52655v-0.52655h-0.52655v0.52655h-0.52655v-0.52655h-1.0531v0.52655h-0.52655v-0.52655h-0.52655v-0.52656h-1.0531v0.52656h-0.52655v-0.52656zm12.111 0v0.52656h0.52655v-0.52656zm-10.531 0.52656v0.52655h0.52655v-0.52655zm1.5797 0.52655v0.52655h0.52655v-0.52655zm10.004 0v0.52655h0.52655v-0.52655zm-8.9514 1.0531v0.52656h0.52655v-0.52656zm6.3186 0v0.52656h-0.52655v0.52654h1.5797v-1.0531zm-8.9514 0.52656v0.52654h0.52655v-0.52654zm1.0531 0v1.0531h0.52655v0.52655h0.52655v0.52655h0.52655v-0.52655h1.0531v-0.52655h-0.52655v-0.52656h-0.52655v1.0531h-0.52655v-0.52655h-0.52655v-0.52656h0.52655v-0.52654zm4.739 0v0.52654h0.52655v-0.52654zm-1.5797 0.52654v0.52656h0.52655v-0.52656zm5.2655 1.5797v0.52655h0.52655v-0.52655zm-1.5797 1.5796v1.5797h1.5797v-1.5797zm2.1062 0v0.52656h1.0531v-0.52656zm-1.5797 0.52656v0.52656h0.52655v-0.52656zm-4.2124 0.52656v0.52654h0.52655v-0.52654zm1.0531 0v1.0531h0.52655v-1.0531zm1.5797 0.52654v1.0531h-0.52655v0.52655h0.52655v-0.52655h0.52655v-1.0531zm3.6859 1.0531v0.52655h-0.52655v0.52655h-0.52655v0.52656h1.5797v-1.0531h0.52655v0.52655h0.52655v-0.52655h-0.52655v-0.52655zm-9.4779 1.0531v0.52656h0.52655v-0.52656zm6.8452 0v0.52656h1.0531v-0.52656z",
    display: "inline",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 0.52655
  })), /*#__PURE__*/React.createElement("rect", {
    x: -34.557,
    y: 243.37,
    width: 16.332,
    height: 16.322,
    ry: 0,
    display: "inline",
    fill: "none",
    shapeRendering: "geometricPrecision",
    stroke: "#fff",
    strokeWidth: 1.0642,
    style: {
      paintOrder: "stroke markers fill"
    }
  })), /*#__PURE__*/React.createElement("text", {
    x: 37.044231,
    y: 257.86972,
    display: "inline",
    fill: "#ffffff",
    fillRule: "evenodd",
    fontFamily: "Arial",
    fontSize: "2.3184px",
    letterSpacing: "0px",
    strokeWidth: 0.26952,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 37.044231,
    y: 257.86972,
    strokeWidth: 0.26952,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "For more information about this issue and possible fixes, visit https://www.linkedin.com/in/ali-bouta"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.044231,
    y: 260.18814,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 37.044231,
    y: 262.50659,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), /*#__PURE__*/React.createElement("text", {
    x: 37.018196,
    y: 264.94397,
    display: "inline",
    fill: "#ffffff",
    fillRule: "evenodd",
    fontFamily: "Arial",
    fontSize: "2.3184px",
    letterSpacing: "0px",
    strokeWidth: 0.26952,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 37.018196,
    y: 264.94397,
    strokeWidth: 0.26952,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "If you call a support person, give them this info"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.018196,
    y: 267.26239,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 37.018196,
    y: 269.58084,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })), /*#__PURE__*/React.createElement("text", {
    x: 37.148396,
    y: 268.5322,
    display: "inline",
    fill: "#ffffff",
    fillRule: "evenodd",
    fontFamily: "Arial",
    fontSize: "1.9149px",
    letterSpacing: "0px",
    strokeWidth: 0.22261,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 37.148396,
    y: 268.5322,
    strokeWidth: 0.22261,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }, "Stop code: CRITICAL PROCESS DIED"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.148396,
    y: 270.44708,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 37.148396,
    y: 272.36197,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    display: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(90)",
    x: 148.47,
    y: -130,
    width: 25,
    height: 25,
    ry: 12.5,
    display: "inline",
    fill: "url(#d)",
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -148.47,
    y: 80,
    width: 25,
    height: 25,
    display: "inline",
    fill: "url(#c)",
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-90)",
    x: -148.47,
    y: 105,
    width: 25,
    height: 25,
    ry: 0,
    display: "inline",
    fill: "url(#k)",
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(0,1,1,0,0,0)",
    x: 148.47,
    y: 80,
    width: 25,
    height: 25,
    display: "inline",
    fill: "url(#j)",
    style: {
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 84.159241,
    y: 146.03641,
    display: "inline",
    fill: "#ffffff",
    fontFamily: "Arial",
    fontSize: "28.565px",
    letterSpacing: "0px",
    strokeWidth: 4.1733,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    x: 84.159241,
    y: 146.03641,
    fill: "#ffffff",
    strokeWidth: 4.1733
  }, "+"))), /*#__PURE__*/React.createElement("text", {
    transform: "scale(1.2087 .82736)",
    x: 91.457924,
    y: 173.28868,
    display: "inline",
    fill: "#ffffff",
    fontFamily: "Arial",
    fontSize: "34.525px",
    letterSpacing: "0px",
    strokeWidth: 5.0442,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 91.457924,
    y: 173.28868,
    strokeWidth: 5.0442
  }, "-"))), /*#__PURE__*/React.createElement("text", {
    x: 86.414261,
    y: 167.52353,
    display: "inline",
    fill: "#ffffff",
    fontFamily: "Arial",
    fontSize: "18.302px",
    letterSpacing: "0px",
    strokeWidth: 2.6739,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 86.414261,
    y: 167.52353,
    fill: "#ffffff",
    strokeWidth: 2.6739
  }, "X"))), /*#__PURE__*/React.createElement("text", {
    x: 109.15925,
    y: 171.0912,
    display: "inline",
    fill: "#ffffff",
    fontFamily: "Arial",
    fontSize: "28.565px",
    letterSpacing: "0px",
    strokeWidth: 4.1733,
    wordSpacing: "0px",
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      lineHeight: 1,
      paintOrder: "stroke markers fill"
    },
    xmlSpace: "preserve"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 109.15925,
    y: 171.0912
  }, "="))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.968713af02b2fa020ada13bda32e72fb.svg";
export { ForwardRef as ReactComponent };